import React, { useEffect, useRef, useState } from "react";
import { Container } from "reactstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Row } from "reactstrap";

// images
import zithasLogo from "../../assets/images/zithas-dark-logo.png";
import sign from "../../assets/images/signature.png";
import axios from "axios";
import Loader from "pages/Separate/Loader";
import moment from "moment";
import configure from "configure";
import { useReactToPrint } from "react-to-print";
import html2pdf from "html2pdf.js";
import { onDownloadPdf } from "utils/common-helpers";

const ViewApproveDoc = () => {
  const [fixedRightSec, setFixedRightSec] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 48) setFixedRightSec(true);
      else setFixedRightSec(false);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const printContract = () => {
    let printContents = document.getElementById("zithasInvoicePrint").innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };

  const [isLoading, setLoading] = useState(false);
  const [contract_type, setContractType] = useState([]);
  const [contract_value, setContractValue] = useState("");
  const [description, setDescription] = useState("");
  const [start_date, setStartDate] = useState("");
  const [end_date, setEndDate] = useState("");
  const [note, setNote] = useState("");
  const [date, setDate] = useState("");
  const [sign_date, setSignDate] = useState("");
  const [downLink, setDownLink] = useState("");
  const [signature, setSignature] = useState("");
  const [contact, setContact] = useState("");
  const [name, setName] = useState("");
  const [documentType, setDocumentType] = useState("")

  const params = useParams();

  function addNoBreakInline(html) {
    // Make paragraphs / lists / divs avoid breaks
    html = html
      .replace(
        /<p([^>]*)>/g,
        `<p$1 style="page-break-inside: avoid; break-inside: avoid;">`
      )
      .replace(
        /<li([^>]*)>/g,
        `<li$1 style="page-break-inside: avoid; break-inside: avoid;">`
      )
      .replace(
        /<ul([^>]*)>/g,
        `<ul$1 style="page-break-inside: avoid; break-inside: avoid;">`
      )
      .replace(
        /<ol([^>]*)>/g,
        `<ol$1 style="page-break-inside: avoid; break-inside: avoid;">`
      )
      .replace(
        /<div([^>]*)>/g,
        `<div$1 style="page-break-inside: avoid; break-inside: avoid; padding-top: 30px;">`
      )
      .replace(
        /<h([1-4])([^>]*)>/g,
        `<h$1$2 style="page-break-inside: avoid; break-inside: avoid; padding-top: 30px;">`
      );

    html = html.replace(
      /<table([^>]*)>/g,
      `<div style="page-break-inside: avoid; break-inside: avoid; padding-top: 30px;"><table$1>`
    );

    html = html.replace(/<\/table>/g, `</table></div>`);

    return html;
  }

  const fetchNodeData = async () => {
    setLoading(true);
    try {
      const staffId = localStorage.getItem("auth_id");
      const response = await axios({
        method: "get",
        url: `${configure.nodeApi}/showStaffLetter/${params?.id}`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      // console.log("response: ", response);
      if (response) {
        setLoading(false);
        const filterData = response?.data?.data;
        const templateData = response?.data?.data?.final_template;
        setSignature(response?.data?.data?.signature);
        setName(response?.data?.data?.name);
        setDocumentType(response?.data?.data?.LetterTemplate)
        setDownLink(filterData[0]?.signature);
        const htmlRaw = response?.data?.data?.final_template;
        let cleanHTML = htmlRaw
          .replaceAll("{", "")
          .replaceAll("}", "")
          // .replace(/<p[^>]*>(\s|&nbsp;|<br>|<br\/>|<br \/>)*<\/p>/gi, "")
          // .replace(/<p([^>]*)>\s*&nbsp;+/gi, "<p$1>")
          // .replace(/<p([^>]*)><br\s*\/?>/gi, "<p$1>")
          // .replace(/^(\s|<br\s*\/?>)+/gi, "");
        const processed = addNoBreakInline(cleanHTML);
        setDescription(processed);
        // setDescription(templateData);
        setSignDate(filterData[0]?.sign_date);
        setDate(filterData[0]?.created_at);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  useEffect(() => {
    fetchNodeData();
  }, []);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const allowDownload = query.get("download") === "1";

  const contentRef = useRef(null);
  const reactToPrintFn = useReactToPrint({
    contentRef,
  });

  // const onDownload = () => {
  //   setLoading(true);

  //   setTimeout(() => {
  //     const content = contentRef.current;

  //     const opt = {
  //       filename: `${documentType || "Letter"}.pdf`,
  //       image: { type: "jpeg", quality: 0.98 },
  //       html2canvas: { dpi: 192, letterRendering: true, scale: 2 },
  //       jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
  //     };

  //     html2pdf()
  //       .from(content)
  //       .set(opt)
  //       .save()
  //       .finally(() => {
  //         setLoading(false);
  //       });
  //   }, 150);
  // };

  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: documentType,
    removeAfterPrint: true,
    pageStyle: `
      @page { 
        size: A4; 
        margin: 0.5in; 
      }
      @media print {
        body { -webkit-print-color-adjust: exact; }
        #printableLetter {
          padding: 40px 70px !important;
        }
        .text-center img {
          height: 80px !important;
        }
      }
    `,
  });

  return (
    <div>
      {isLoading && <Loader />}
      <div className="page-content mb-4">
        <Container fluid>
          <Breadcrumbs title={"Dashboard"} breadcrumbItem={"View Document"} />
          <Row>
            {/* <div className="col-md-10 ps-0"> */}
            <div
              className={allowDownload ? "col-md-10 ps-0" : "col-md-12 ps-0"}
            >
              <div
                id="printableLetter"
                ref={contentRef}
                className="bg-white shadow document"
                style={{
                  paddingLeft: "120px",
                  paddingRight: "120px",
                  paddingTop: "30px",
                  paddingBottom: "50px",
                }}
              >
                <div
                  className="pb-2 text-center"
                  style={{ marginBottom: "20px", paddingTop: "20px" }}
                >
                  <img
                    src={zithasLogo}
                    height="80"
                    alt="zithasLogo"
                    style={{ maxHeight: "80px" }}
                  />
                </div>
                <div>
                  <div>
                    <div
                      className="Features document-content"
                      dangerouslySetInnerHTML={{
                        __html: description,
                        // ?.replaceAll("{", "")
                        // .replaceAll("}", "")
                      }}
                    />
                  </div>

                  <h5 className="fw-bold text-decoration-underline">
                    Date : {moment(date).format("DD-MM-YYYY")}
                  </h5>
                  <Row className="mt-4 d-flex justify-content-between ">
                    <div className="col-6">
                      {signature == null ? (
                        <div className="sign-box">Signature</div>
                      ) : (
                        <img src={sign} height="50" className="mb-2" />
                      )}
                      <h5>Zithas Signature</h5>
                    </div>

                    <div className="col-6 text-end">
                      {signature ? (
                        <>
                          <img src={signature} height="50" className="mb-2" />
                          <h5 className="mr-4 " style={{ marginRight: "40px" }}>
                            {name || "Signature"}
                          </h5>
                        </>
                      ) : null}
                    </div>
                  </Row>
                </div>
              </div>
            </div>
            {allowDownload && (
              <div className="col-md-2 pe-md-0 order-md-2 order-1 mb-md-0 mb-3 mt-4">
                <div
                  className={`${
                    fixedRightSec ? "fixed-right-section top-0 " : ""
                  }`}
                >
                  {/* buttons */}
                  <div className="col-12 text-xl-start text-center">
                    <button
                      className="btn btn-sm btn-success border-radius me-1"
                      onClick={handlePrint}
                    >
                      <i className="fas fa-print me-1"></i> Print
                    </button>

                    <button
                      className="btn btn-sm btn-secondary border-radius"
                      onClick={() => onDownloadPdf(setLoading, contentRef, documentType)}
                    >
                      <i className="fas fa-file-download me-1"></i> Download
                    </button>
                  </div>
                </div>
              </div>
            )}
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default ViewApproveDoc;
